import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TIndexTypeAttribute {
  id?: number;
  indexTypeId: number;
  attribute: string;
  required: boolean;
  valid: boolean;
}

export interface IIndexTypeAttribute extends TIndexTypeAttribute {}

const IndexTypeAttribute = Model(
  (model: TIndexTypeAttribute): IIndexTypeAttribute => {
    const _value: TIndexTypeAttribute = Object.assign({}, model);
    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get indexTypeId() {
        return _value.indexTypeId;
      },
      set indexTypeId(value) {
        _value.indexTypeId = value;
      },
      get attribute() {
        return _value.attribute;
      },
      set attribute(value) {
        _value.attribute = value;
      },
      get required() {
        return _value.required;
      },
      set required(value) {
        _value.required = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      }
    };

    return ValidatableObject<IIndexTypeAttribute>(_model);
  }
);

export default IndexTypeAttribute;
